import { DeviceWithoutGatewayFormOptionsModel } from 'components/organisms/DevicesWithoutGatewayForm/models';
import { DeviceTypeWithoutGatewayDataModel } from 'core/domain/devices/models';

export interface CreateDeviceOptionsLiteralsModel {
  deviceActionButtonText: string;
  title: string;
  mainButtonText: string;
  secondaryButtonText: string;
  infoText: string;
  typeSectionTitle: string;
  deviceTypeLabel: string;
  deviceTypePlaceholder: string;
}

export interface CreateDeviceOptionsModel {
  literals: CreateDeviceOptionsLiteralsModel;
  devicesTypes: DeviceTypeWithoutGatewayDataModel[];
  formType: string | null;
  formOptions: DeviceWithoutGatewayFormOptionsModel;
  onOpenCreateDeviceDrawer: () => void;
  onCloseCreateDeviceDrawer: () => void;
  onChangeDeviceType: (value: string) => void;
  onAddDevice: () => void;
  createDeviceDrawerVisible: boolean;
  loading: boolean;
  hasDevicesTypes: boolean;
  creating: boolean;
  submitButtonDisabled: boolean;
}

export enum CreateDeviceErrorCodeType {
  CONFLICTS = 400,
  PAYLOAD_ERROR = 422,
}
